import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import React from 'react';
import { useSelector } from 'react-redux';
import CreditorSelect from '../../CreditorSelect.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const CreditorsGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.creditorsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.creditorIds && caseFilter.creditorIds.length), onDeactivate: () => caseFilterStore.clearFilter('creditorIds') },
            React.createElement(CreditorSelect, { multi: true, style: { width: '100%', marginRight: '20px' }, value: caseFilter.creditorIds ?? [], onChange: (creditorIds) => {
                    caseFilterStore.setSelectedCreditors(creditorIds);
                    props.onChange?.(creditorIds);
                } }))));
};
export default CreditorsGroup;
//# sourceMappingURL=CreditorsGroup.js.map